import React from 'react';

import { ShopProps } from '@/pages/solucoes-de-pagamentos-digitais';

import Banner from './components/Banner';
import Clients from './components/Clients';
import Pagarme from './components/Pagarme';

const Store: React.FC<ShopProps> = ({
  banner,
  enterprisesCard,
  bannerCards,
  featureCards,
}) => {
  return (
    <>
      {banner && (
        <Banner
          id={banner.referId}
          title={banner.titleDescriptionTag.title}
          description={banner.titleDescriptionTag.description}
          machineImage={banner.machineImage}
          bannerImages={banner.bannerImages}
        />
      )}
      {enterprisesCard && (
        <Clients
          id={enterprisesCard.referId}
          title={enterprisesCard.title}
          images={enterprisesCard.images}
        />
      )}
      {bannerCards && (
        <Pagarme
          id={bannerCards.referId}
          pagarmeImages={bannerCards.pagarmeImages}
          title={bannerCards.title}
          subTitle={bannerCards.subTitle}
          cards={bannerCards.bannerCards}
          features={featureCards}
        />
      )}
    </>
  );
};

export default Store;
